// extracted by mini-css-extract-plugin
export default {"main":"Main_main__tHKDn","header":"Main_header__PsCCo","title":"Main_title__bwARM","createPost":"Main_createPost__TbfZq","posts":"Main_posts__YoQCM"};